"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { fetchJson } from "@/utils/fetch";
export function useCustomVisitTracking() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = [pathname];
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  React.useEffect(_temp2, t0);
}
function _temp2() {
  if (typeof window === "undefined") {
    return;
  }
  const pageUrl = window.location.href;
  fetchJson("/career/track_visits", {
    method: "POST",
    body: JSON.stringify({
      page_url: pageUrl
    }),
    skipRedirection: true
  }).catch(_temp);
}
function _temp() {}
export default function CustomVisitTracking() {
  useCustomVisitTracking();
  return null;
}